/**
 * @fileoverview Componente responsável por filtrar tickets por fila.
 *
 * O valor `NO_QUEUE_SENTINEL` (0) representa a opção "Sem fila" — quem consome
 * a lista deve converter pra `null` antes de mandar pro backend (ids de fila
 * reais começam em 1, então 0 é livre como sentinela).
 */

import React from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Checkbox, ListItemText } from "@material-ui/core";
import { i18n } from "../../translate/i18n";

export const NO_QUEUE_SENTINEL = 0;

const TicketsQueueSelect = ({
	userQueues,
	selectedQueueIds = [],
	onChange,
	wrapperStyle,
	formControlClassName,
	selectClassName,
	menuPaperClassName,
	placeholderText,
}) => {
	const handleChange = e => {
		onChange(e.target.value);
	};

	return (
		<div style={wrapperStyle || { width: 120, marginTop: -4 }}>
			<FormControl fullWidth margin="dense" className={formControlClassName}>
				<Select
					multiple
					displayEmpty
					variant="outlined"
					className={selectClassName}
					value={selectedQueueIds}
					onChange={handleChange}
					MenuProps={{
						classes: { paper: menuPaperClassName },
						anchorOrigin: {
							vertical: "bottom",
							horizontal: "left",
						},
						transformOrigin: {
							vertical: "top",
							horizontal: "left",
						},
						getContentAnchorEl: null,
					}}
					renderValue={() => placeholderText || i18n.t("ticketsQueueSelect.placeholder")}
				>
					<MenuItem dense value={NO_QUEUE_SENTINEL}>
						<Checkbox
							size="small"
							color="primary"
							checked={selectedQueueIds.indexOf(NO_QUEUE_SENTINEL) > -1}
						/>
						<ListItemText
							primary={i18n.t("ticketsQueueSelect.noQueue")}
							primaryTypographyProps={{ style: { fontStyle: "italic" } }}
						/>
					</MenuItem>
					{userQueues?.length > 0 &&
						userQueues.map(queue => (
							<MenuItem dense key={queue.id} value={queue.id}>
								<Checkbox
									style={{
										color: queue.color,
									}}
									size="small"
									color="primary"
									checked={selectedQueueIds.indexOf(queue.id) > -1}
								/>
								<ListItemText primary={queue.name} />
							</MenuItem>
						))}
				</Select>
			</FormControl>
		</div>
	);
};

export default React.memo(TicketsQueueSelect);
